import { Redirect, Route, Router, useLocation } from 'wouter-preact';
import type { JSX } from 'preact';

import { getSession } from './api.js';
import { AccountView } from './views/AccountView.js';
import { BoxJournalView } from './views/BoxJournalView.js';
import { BoxWeekView } from './views/BoxWeekView.js';
import { FlockProfileView } from './views/FlockProfileView.js';
import { FlockView } from './views/FlockView.js';
import { InviteView } from './views/InviteView.js';
import { LogEntryView } from './views/LogEntryView.js';
import { LogView } from './views/LogView.js';
import { LoginView } from './views/LoginView.js';
import { OfferView } from './views/OfferView.js';
import { PreviewView } from './views/PreviewView.js';
import { RedeemView } from './views/RedeemView.js';
import { MemberFooter, MemberHeader, MemberNav } from './components/MemberChrome.js';

export function App(): JSX.Element {
  const [location] = useLocation();
  return (
    <div class="shell member-shell">
      <a class="ff-skip" href="#member-content">Skip to content</a>
      <MemberHeader />
      <MemberNav location={location} signedIn={Boolean(getSession())} />
      <span id="member-content" tabIndex={-1} />

      <Router>
        <Route path="/" component={() => <Redirect to={getSession() ? '/account' : '/box'} />} />
        <Route path="/go" component={() => <RedeemView />} />
        <Route path="/invite" component={() => <InviteView />} />
        <Route path="/login" component={() => <LoginView />} />
        <Route path="/preview" component={() => <PreviewView />} />
        <Route path="/account" component={() => <AccountView />} />
        <Route path="/log" component={() => <LogView />} />
        <Route path="/log/:slug">{(params: { slug: string }) => <LogEntryView slug={params.slug} />}</Route>
        <Route path="/flock" component={() => <FlockView />} />
        <Route path="/flock/:slug">{(params: { slug: string }) => <FlockProfileView slug={params.slug} />}</Route>
        <Route path="/box" component={() => <BoxJournalView />} />
        <Route path="/box/:id">{(params: { id: string }) => <BoxWeekView id={params.id} />}</Route>
        <Route path="/p/:code">{(params: { code: string }) => <OfferView code={params.code} />}</Route>
      </Router>
      <MemberFooter />
    </div>
  );
}
